import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow",
  "use": "icon-icon-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-arrow\"><!--Generator: Adobe Illustrator 29.0.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 186)--><path d=\"M899.85,724.87H124.01c-33.14,0-60-26.86-60-60s26.86-60,60-60h630.99l-203.32-203.31c-23.43-23.43-23.43-61.42,0-84.85,23.43-23.43,61.42-23.43,84.85,0l305.74,305.74c17.16,17.16,22.29,42.97,13.01,65.39-9.29,22.42-31.17,37.04-55.43,37.04Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol